import { Question } from "../../interfaces/purchase-order.interface";
import { QuestionType } from "../../enums/question-type.enum";

export class commitmentLetterQuestion {
  public static question_commitment_letter: Question[] = [
    {
      type: "radio",
      question: "¿Qué deseas hacer con este documento?",
      control: "question_toDo",
      options: [
        { label: "Aceptarlo", value: { value: true, incident: false } },
        { label: "Rechazarlo", value: { value: false, incident: true, incident_text: "El documento fue rechazado." } },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question:
        "¿En esta carta solo se menciona uno o los dos puntos siguientes: tenencia del ejercicio actual, 3 infracciones más recientes?",
      control: "important_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe de especificar solo los puntos permitidos.",
          },
        },
      ],
      page: 2,
    },
    {
      type: "select",
      question: "¿Quién se hara responsable de resolver los puntos mencionados?",
      control: "text_invoice",
      options: [
        { label: "Agencia", value: { value: "Agencia", incident: false } },
        { label: "Cliente", value: { value: "Cliente", incident: false } },
      ],
      page: 2,
    },

    {
      type: "date-picker",
      question: "¿A más tardar en qué fecha se resolverán los puntos?",
      control: "document_solved",
      label: "Fecha",
      answer: undefined,
      page: 2,
    },
  ];

  public static question_commitment_approved: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "information_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La información no es legible",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La carta menciona que el duplicado de la llave llegará a la agencia el día [DD-MM-AAAA]?",
      formatted_question:
        "¿La carta menciona que el duplicado de la llave llegará a la agencia el día <b>[DD-MM-AAAA]</b>?",
      control: "date_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La carta no incluye la fecha",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El periodo de tiempo es menor a 4 meses para la llegada del duplicado de llave a agencia?",
      formatted_question:
        "¿El <b>periodo de tiempo</b> es <b>menor a 4 meses</b> para la llegada del duplicado de llave a agencia?",
      control: "period_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El periodo de tiempo, no es mayor a 4 meses",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La carta esta sellada y firmada por gerente comercial o director de la agencia?",
      formatted_question: "¿La carta esta <b>sellada y firmada por gerente comercial</b> o director de la agencia?",
      control: "signature_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La firma no corresponde al gerente comercial o director de la agencia",
          },
        },
      ],
      page: 1,
    },
  ];
}
